class ContentOverlay {
  constructor(element, ...options) {
    this.defaults = {
      overlaySelector: '.js-content-overlay',
      iframeSelector: '.js-content-overlay-iframe',
      closeSelector: '.js-close-content-overlay',
      activeClass: '-is-active',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.active = false;

    // if link target is set by another element (e.g. select-list), don't set element variables right away
    if(!this.element.dataset.referral) {
      this.setElements();
    } else {
      // instead query referral element
      this.select = document.querySelector(this.element.dataset.target);
    }

    this.bindEvents();
  }

  setElements() {
    this.overlayElement = document.querySelector(this.options.overlaySelector + this.element.dataset.target);
    this.iframe = this.overlayElement.querySelector(this.options.iframeSelector);
    this.close = [].slice.call(this.overlayElement.querySelectorAll(this.options.closeSelector));

    this.active = this.overlayElement.classList.contains(this.options.activeClass);

    this.bindElementEvents();
  }

  loadFrame(e) {
    if (Cookiebot.consent.marketing) {
      this.iframe.src = (this.overlayElement.classList.contains(this.options.activeClass)) ? this.iframe.dataset.src : '';
    }
  }

  toggleOverlay() {
    this.active = !this.active;
    this.overlayElement.classList.toggle(this.options.activeClass);
    document.documentElement.classList.toggle('no-scroll');

    if (this.iframe) {
      this.loadFrame();
    }
  }

  handleOpen(e) {
    e.preventDefault();

    // if link target is referral, get current value and query elements
    if (this.element.dataset.referral) {
      this.element.dataset.target = this.select.value;
      this.setElements();
    }

    this.toggleOverlay();
  }

  bindEvents() {
    this.element.addEventListener('click', this.handleOpen.bind(this));
  }

  bindElementEvents() {
    this.close.forEach((el) => {
      if (!el.dataset.hasListener) {
        el.addEventListener('click', this.handleOpen.bind(this));
      }

      el.dataset.hasListener = true;
    });

    if (this.iframe) {
      window.addEventListener('CookiebotOnAccept', this.loadFrame.bind(this));
    }
  }
}
